import { useApproveStep } from 'components/StepLine/common/ApproveStep'
import useStepWithNext from 'components/StepLine/context/hooks/useStepWithNext'
import StepLineModal from 'components/StepLine/StepLineModal'
import React from 'react'
import { ThemedText } from 'theme'

import { useRewards } from '../../context/RewardContext'
import KodiakFarmUnstakeStep from '../steps/migration/KodiakFarmUnstakeStep'
import RewardVaultStakeStep from '../steps/migration/RewardVaultStakeStep'

const MigrationModal: React.FC = () => {
  const {
    activeModal,
    closeModal,
    completeMigration,
    kodiakFarmEarned,
    migrationStakingToken,
    kodiakFarm,
    rewardVault,
    unstakeTxState,
    stakeTxState,
    unstakeFromKodiakFarm,
    stakeToRewardVault,
    approveAmount,
    migration,
    canDismissModal,
    totalStakedAmount,
    willForfeitRewards,
    stakedPositions,
    rewardVaultRewardToken,
  } = useRewards()
  const rewardVaultRewardSymbol = rewardVaultRewardToken?.symbol

  const approveStep = useApproveStep(approveAmount, rewardVault?.vaultAddress || undefined)

  const kodiakFarmUnstakeStep = useStepWithNext('kodiakFarmUnstake', KodiakFarmUnstakeStep, {
    earnedAmount: kodiakFarmEarned,
    stakedPositions: migration.inProgress ? migration.snapshot.positions : stakedPositions,
    totalStakedAmount: migration.inProgress ? migration.snapshot.totalStakedAmount : totalStakedAmount,
    stakingToken: migrationStakingToken,
    farm: kodiakFarm || null,
    attemptingTxn: unstakeTxState.attemptingTx,
    willForfeitRewards,
    hash: unstakeTxState.hash,
    autoConfirm: true,
    transactionWaiting: true,
    onStart: unstakeFromKodiakFarm,
    pendingText: 'Unstaking from Kodiak Farm...',
    error: unstakeTxState.error,
  })

  const rewardVaultStakeStep = useStepWithNext('rewardVaultStake', RewardVaultStakeStep, {
    totalStakedAmount: migration.inProgress ? migration.snapshot.totalStakedAmount : totalStakedAmount,
    stakingToken: migrationStakingToken,
    rewardVault: rewardVault || null,
    rewardVaultRewardSymbol,
    attemptingTxn: stakeTxState.attemptingTx,
    hash: stakeTxState.hash,
    autoConfirm: true,
    transactionWaiting: true,
    onStart: stakeToRewardVault,
    pendingText: 'Staking in Reward Vault...',
    error: stakeTxState.error,
  })

  const activeSteps = [kodiakFarmUnstakeStep, approveStep, rewardVaultStakeStep]

  const modalHeader = <ThemedText.DeprecatedMediumHeader>Migrate to Reward Vault</ThemedText.DeprecatedMediumHeader>

  // Handle modal completion
  const handleFinish = () => {
    completeMigration()
    closeModal()
  }

  return (
    <StepLineModal
      isOpen={activeModal === 'migration'}
      onDismiss={closeModal}
      steps={activeSteps}
      header={modalHeader}
      onFinish={handleFinish}
      disableDismiss={!canDismissModal}
      hideCloseIcon={!canDismissModal}
    />
  )
}

export default MigrationModal
